"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AccordionSize = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _rawAccordion = require("./raw-accordion");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function (nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

let AccordionSize = /*#__PURE__*/function (AccordionSize) {
  AccordionSize["Small"] = "small";
  AccordionSize["Medium"] = "medium";
  return AccordionSize;
}({});

exports.AccordionSize = AccordionSize;
/** An accordion component with internal state */

const Accordion = props => {
  const [expanded, setExpanded] = (0, _react.useState)(Boolean(props.initiallyExpanded));
  (0, _react.useEffect)(() => {
    if (props.initiallyExpanded) {
      setExpanded(Boolean(props.initiallyExpanded));
    }
  }, [props.initiallyExpanded]);

  const onClick = () => {
    setExpanded(!expanded);

    if (props.onClick) {
      props.onClick(!expanded);
    }
  };

  return /*#__PURE__*/_react.default.createElement(_rawAccordion.RawAccordion, (0, _extends2.default)({}, props, {
    expanded: expanded,
    onClick: onClick
  }));
};

Accordion.propTypes = {
  type: _propTypes.default.oneOf(['small', 'medium']).isRequired,
  label: _propTypes.default.string,
  sublabel: _propTypes.default.string,
  initiallyExpanded: _propTypes.default.bool,
  headerElement: _propTypes.default.node,
  name: _propTypes.default.string,
  classNames: _propTypes.default.shape({
    wrapper: _propTypes.default.string,
    header: _propTypes.default.string,
    label: _propTypes.default.string,
    sublabel: _propTypes.default.string,
    content: _propTypes.default.string,
    expanded: _propTypes.default.string
  }),
  id: _propTypes.default.string
};
var _default = Accordion;
exports.default = _default;